import scientificSolutions from "../assets/img/website_06.png";
// import Pepole from "../assets/img/website_10.png";
// import pen from "../assets/img/website_12.png";
// import Geometry from "../assets/img/website_11.jpg";
// import Pen_Hand from "../assets/img/website_09.jpg";
// import { title } from "framer-motion/client";

const subServiceContent = {
  scientificTechnology: {
    title: "Scientific & Technology Solutions",
    // subtitle: "Science-Driven Strategy for Innovation and Growth",
    // description: [
    //   "Stay ahead of innovation with strategic, science-driven solutions tailored to your business goals. Whether you're refining an idea or scaling a breakthrough, Lifeintelect brings cross-functional expertise—from academia and industry—to support every stage of your innovation journey. with insights rooted in deep scientific, operational, and strategic knowledge, you gain the clarity to make confident, future-ready decisions.",
    // ],
    // patent_info: {
    // //   title: "Lifeintelect’s expertise extends across a wide range of sectors, including:",
    // //   description: "Lifeintelect’s expertise extends across a wide range of sectors, ensuring tailored solutions for diverse industries.",
    //   typesSection: {
    //     Heading: "Lifeintelect’s expertise extends across a wide range of sectors, including:",
    //     types: [
    //       { title: "Life Sciences" },
    //       { title: "Healthcare" },
    //       { title: "Pharmaceuticals" },
    //       { title: "Biotechnology" },
    //       { title: "Medical Technology" },
    //       { title: "Agriculture" },
    //       { title: "Natural Medicine" },
    //       { title: "Fisheries" },
    //       { title: "Biofuels" },
    //       { title: "Materials Processing & Synthesis" },
    //       { title: "Nanotechnology Research and Applications" },
    //       { title: "Clinical Research" },
    //       { title: "Chemistry" },
    //       { title: "Drug Discovery" },
    //       { title: "Environmental Solutions" },
    //       { title: "Blockchain Technology and AI" },
    //     ],
    // 	closing:"By providing in-depth evaluations of R&D, technology, industry shifts, and market trends, we empower you to make informed decisions, shape your business strategy, and seize growth opportunities.",
    //   },
    // },
    service_1: {
      title: "Scientific & Technology Solutions",
      subtitle: "Science-Driven Strategy for Innovation and Growth",
      description: [
        "Stay ahead of innovation with strategic, science-driven solutions tailored to your business goals. Whether you're refining an idea or scaling a breakthrough, Lifeintelect brings cross-functional expertise—from academia and industry—to support every stage of your innovation journey. with insights rooted in deep scientific, operational, and strategic knowledge, you gain the clarity to make confident, future-ready decisions.",
        "Lifeintelect’s expertise extends across a wide range of sectors, including:",
      ],
      Accordion: [
        {
          title: "Life Sciences & Biomedicine",
          description:
            "Breakthroughs in biology demand bulletproof legal strategies.",
          typesSection: {
            Heading: "Core Domains: ",
            types: [
              {
                // title: "Novel",
                description: "Molecular & Cell Biology",
              },
              {
                description: "Genomics & Proteomics",
              },
              {
                // title: "Industrially applicable",
                description: "Stem Cell & Regenerative Medicine",
              },
              {
                // title: "Industrially applicable",
                description: "Immunology & Vaccines",
              },
              {
                // title: "Industrially applicable",
                description: "Neuroscience & Brain Technologies",
              },
            ],
          },
        },
        {
          title: "Mechanical, Electronics & Telecommunications",
          description:
            "From machines to mobile—engineering innovation with legal clarity.",
          typesSection: {
            Heading: "Core Domains: ",
            types: [
              {
                description: "Mechatronics & Mechanical Systems",
              },
              {
                description: "Electronics & Robotics",
              },
              {
                description: "Instrumentation & Control Systems",
              },
              {
                description: "5G, IoT & Telecommunication Systems",
              },
              {
                description: "Power Electronics & Automation",
              },
              {
                description: "Semiconductor",
              },
              {
                description: "Micro-Electro-Mechanical Systems(MEMS)",
              },
            ],
          },
        },
        {
          title: "Software, Digital Platforms & Emerging Tech",
          description: "Protecting innovation in the code and in the cloud.",
          typesSection: {
            Heading: "Core Domains: ",
            types: [
              {
                description:
                  "Artificial Intelligence (AI) & Machine Learning (ML)",
              },
              {
                description: "Software as a Medical Device (SaMD)",
              },
              {
                description: "Blockchain in Healthcare & IP",
              },
              {
                description: "Clinical Decision Support Systems",
              },
              {
                description: "Bioinformatics & Data Security",
              },
            ],
          },
        },
        {
          title: "Pharmaceuticals & Drug Development",
          description:
            "From molecule to market—legally fortified every step of the way.",
          typesSection: {
            Heading: "Core Domains: ",
            types: [
              {
                // title: "Novel",
                description: "Drug Discovery & Lead Optimization",
              },
              {
                // title: "Inventive",
                description: "PK/PD & Preclinical Strategy",
              },
              {
                // title: "Industrially applicable",
                description: "Regulatory Affairs & Clinical Trials",
              },
              {
                description: "Drug Formulations & Delivery Systems",
              },
            ],
          },
        },
        {
          title: "Biotechnology & Industrial Biosciences",
          description: "Where biology powers industries—your IP fuels success.",
          typesSection: {
            Heading: "Core Domains: ",
            types: [
              {
                description: "CRISPR & Gene Editing",
              },
              {
                description: "Synthetic Biology",
              },
              {
                description: "Bioprocess Engineering",
              },
              {
                description: "Enzyme & Microbial Technologies",
              },
            ],
          },
        },
        {
          title: "Healthcare, Dentistry & Medical Technology",
          description:
            "Modern medicine meets smart IP and regulatory solutions.",
          typesSection: {
            Heading: "Core Domains: ",
            types: [
              {
                description: "Medical Devices & Diagnostics",
              },
              {
                description: "Digital Health & Personalized Care",
              },
              {
                description: "Clinical Research",
              },
              {
                description: "Telemedicine ",
              },
              {
                description: "Dental Technology & Oral Innovations",
              },
            ],
          },
        },
        {
          title: "Agriculture, Natural Products & Sustainability",
          description:
            "Protecting nature-inspired innovations and green technologies.",
          typesSection: {
            Heading: "Core Domains: ",
            types: [
              {
                description: "AgriTech & Precision Farming",
              },
              {
                description: "Nutraceuticals",
              },
              {
                description: "Clinical Research",
              },
              {
                description: "Fisheries & Marine Biotechnology",
              },
              {
                description: "Environmental Biotech & Bioremediation",
              },
            ],
          },
        },
        {
          title: "Materials Science, Nanotech & Energy",
          description: "Strategizing IP at the atomic level and beyond.",
          typesSection: {
            Heading: "Core Domains: ",
            types: [
              {
                description: "Nanotechnology & Nano-enabled Devices",
              },
              {
                description: "Advanced Materials & Composites",
              },
              {
                description: "Smart Polymers & Functional Surfaces",
              },
              {
                description: "Green Chemistry",
              },
              {
                description: "Renewable Energy & Biofuels",
              },
            ],
          },
        },
        {
          title: "Automotive & Mobility Innovations",
          description:
            "Accelerating IP strategy in the fast lane of innovation.",
          typesSection: {
            Heading: "Core Domains: ",
            types: [
              {
                description: "Electric & Hybrid Vehicles (EV/HEV)",
              },
              {
                description: "Autonomous & Connected Vehicles",
              },
              {
                description: "Automotive Sensors & Control Systems",
              },
              {
                description: "Telematics & In-Vehicle Communication",
              },
              {
                description: "Lightweight & Sustainable Materials",
              },
            ],
          },
        },

      ],
      closing:
        "By providing in-depth evaluations of R&D, technology, industry shifts, and market trends, we empower you to make informed decisions, shape your business strategy, and seize growth opportunities.",
    },

    // service_2: {
    //   title: "Life Sciences & Biomedicine",
    //   subtitle: "Breakthroughs in biology demand bulletproof legal strategies.",
    //   //   description:"A full-spectrum view of your intellectual property reveals untapped value and hidden risks—critical for making informed, strategic decisions.",
    //   processTitle: "Core Domains:",
    //   process: [
    //     {
    //       description: "Molecular & Cell Biology",
    //     },
    //     {
    //       description: "Genomics & Proteomics",
    //     },
    //     {
    //       description: "Stem Cell & Regenerative Medicine",
    //     },
    //     {
    //       description: "Immunology & Vaccines",
    //     },
    //     {
    //       description: "Neuroscience & Brain Technologies",
    //     },
    //   ],
    //   // closing:"Turn oversight into opportunity with insights that inform long-term growth.",
    // },
    // service_3: {
    //   title: "Pharmaceuticals & Drug Development",
    //   subtitle: "From molecule to market—legally fortified every step of the way.",
    //   //   description:"A full-spectrum view of your intellectual property reveals untapped value and hidden risks—critical for making informed, strategic decisions.",
    //   processTitle: "Core Domains:",
    //   process: [
    //     {
    //       description: "Drug Discovery & Lead Optimization",
    //     },
    //     {
    //       description: "PK/PD & Preclinical Strategy",
    //     },
    //     {
    //       description: "Biopharmaceuticals & Biosimilars",
    //     },
    //     {
    //       description: "Regulatory Affairs & Clinical Trials",
    //     },
    //     {
    //       description: "Drug Formulations & Delivery Systems",
    //     },
    //   ],
    // closing:"Turn oversight into opportunity with insights that inform long-term growth.",
    // },
    // service_4: {
    //   title: "Biotechnology & Industrial Biosciences",
    //   subtitle: "Where biology powers industries—your IP fuels success.",
    //   //   description:"A full-spectrum view of your intellectual property reveals untapped value and hidden risks—critical for making informed, strategic decisions.",
    //   processTitle: "Core Domains:",
    //   process: [
    //     {
    //       description: "CRISPR & Gene Editing",
    //     },
    //     {
    //       description: "Synthetic Biology",
    //     },
    //     {
    //       description: "Bioprocess Engineering",
    //     },
    //     {
    //       description: "Enzyme & Microbial Technologies",
    //     },

    //   ],
    //   // closing:"Turn oversight into opportunity with insights that inform long-term growth.",
    // },
    // service_5: {
    //   title: "Healthcare, Dentistry & Medical Technology",
    //   subtitle: "Modern medicine meets smart IP and regulatory solutions.",
    //   //   description:"A full-spectrum view of your intellectual property reveals untapped value and hidden risks—critical for making informed, strategic decisions.",
    //   processTitle: "Core Domains:",
    //   process: [
    //     {
    //       description: "Medical Devices & Diagnostics",
    //     },
    //     {
    //       description: "Digital Health & Personalized Care",
    //     },
    //     {
    //       description: "Clinical Research",
    //     },
    //     {
    //       description: "Telemedicine ",
    //     },
    //     {
    //       description: "Dental Technology & Oral Innovations",
    //     },
    //   ],
    //   // closing:"Turn oversight into opportunity with insights that inform long-term growth.",
    // },
    // service_6: {
    //   title: "Agriculture, Natural Products & Sustainability",
    //   subtitle: "Protecting nature-inspired innovations and green technologies.",
    //   //   description:"A full-spectrum view of your intellectual property reveals untapped value and hidden risks—critical for making informed, strategic decisions.",
    //   processTitle: "Core Domains:",
    //   process: [
    //     {
    //       description: "AgriTech & Precision Farming",
    //     },
    //     {
    //       description: "Nutraceuticals",
    //     },
    //     {
    //       description: "Fisheries & Marine Biotechnology",
    //     },
    //     {
    //       description: "Environmental Biotech & Bioremediation",
    //     },

    //   ],
    //   // closing:"Turn oversight into opportunity with insights that inform long-term growth.",
    // },
    // service_7: {
    //   title: "Materials Science, Nanotech & Energy",
    //   subtitle: "Strategizing IP at the atomic level and beyond.",
    //   //   description:"A full-spectrum view of your intellectual property reveals untapped value and hidden risks—critical for making informed, strategic decisions.",
    //   processTitle: "Core Domains:",
    //   process: [
    //     {
    //       description: "Nanotechnology & Nano-enabled Devices",
    //     },
    //     {
    //       description: "Advanced Materials & Composites",
    //     },
    //     {
    //       description: "Smart Polymers & Functional Surfaces",
    //     },
    //     {
    //       description: "Green Chemistry",
    //     },
    //     {
    //       description: "Renewable Energy & Biofuels",
    //     },
    //   ],
    //   // closing:"Turn oversight into opportunity with insights that inform long-term growth.",
    // },
    // service_8: {
    //   title: "Mechanical, Electronics & Telecommunications",
    //   subtitle: "From machines to mobile—engineering innovation with legal clarity",
    //   //   description:"A full-spectrum view of your intellectual property reveals untapped value and hidden risks—critical for making informed, strategic decisions.",
    //   processTitle: "Core Domains:",
    //   process: [
    //     {
    //       description: "Mechatronics & Mechanical Systems",
    //     },
    //     {
    //       description: "Electronics & Robotics",
    //     },
    //     {
    //       description: "Instrumentation & Control Systems",
    //     },
    //     {
    //       description: "5G, IoT & Telecommunication Systems",
    //     },
    //     {
    //       description: "Power Electronics & Automation",
    //     },
    //   ],
    //   // closing:"Turn oversight into opportunity with insights that inform long-term growth.",
    // },
    // service_8: {
    //   title: "Automotive & Mobility Innovations",
    //   subtitle: "Accelerating IP strategy in the fast lane of innovation.",
    //   //   description:"A full-spectrum view of your intellectual property reveals untapped value and hidden risks—critical for making informed, strategic decisions.",
    //   processTitle: "Core Domains:",
    //   process: [
    //     {
    //       description: "Electric & Hybrid Vehicles (EV/HEV)",
    //     },
    //     {
    //       description: "Autonomous & Connected Vehicles",
    //     },
    //     {
    //       description: "Automotive Sensors & Control Systems",
    //     },
    //     {
    //       description: "Telematics & In-Vehicle Communication",
    //     },
    //     {
    //       description: "Lightweight & Sustainable Materials",
    //     },
    //   ],
    //   // closing:"Turn oversight into opportunity with insights that inform long-term growth.",
    // },
    // service_9: {
    //   title: "Software, Digital Platforms & Emerging Tech",
    //   subtitle: "Protecting innovation in the code and in the cloud.",
    //   //   description:"A full-spectrum view of your intellectual property reveals untapped value and hidden risks—critical for making informed, strategic decisions.",
    //   processTitle: "Core Domains:",
    //   process: [
    //     {
    //       description: "Artificial Intelligence (AI) & Machine Learning (ML)",
    //     },
    //     {
    //       description: "Software as a Medical Device (SaMD)",
    //     },
    //     {
    //       description: "Blockchain in Healthcare & IP",
    //     },
    //     {
    //       description: "Clinical Decision Support Systems",
    //     },
    //     {
    //       description: "Bioinformatics & Data Security",
    //     },
    //   ],
    //   // closing:"Turn oversight into opportunity with insights that inform long-term growth.",
    // },
    service_2: {
      title: "Drug Discovery & Development",
      subtitle: "Accelerate Your Drug Development Journey",
      description: [
        "The life sciences and healthcare sectors are rapidly evolving, driven by new technologies and innovations. To stay ahead, making data-driven decisions early in the drug development process is crucial. Drug profiling is key to assessing a drug's efficacy, safety, and market potential, even before clinical trials begin.",
        "with expertise in therapeutic clinical intelligence and competitive analysis, we provide in-depth insights into the competitive landscape, ongoing clinical trials, and emerging therapies, empowering you to make more informed, strategic decisions throughout the drug discovery process.",
      ],
    },
    service_3: {
      title: "Assessment of Clinical & Commercial Potential ",
      subtitle: "Position Your Innovations for Success",
      description: [
        "Evaluating the clinical and commercial potential of patented technologies is essential to ensure they align with market needs and address key healthcare challenges. By analyzing clinical trials, FDA approvals, and emerging biotech trends, the real-world applicability of innovations is assessed.",
        "Through market size estimation, projected growth, and return on investment (ROI) analysis, you can position your technology for success. Tailored patent licensing and commercialization strategies open the door to partnerships and opportunities, optimizing both the financial and strategic value of your innovations.",
      ],
    },
    service_4: {
      title: "Management Consulting",
      subtitle: "Navigate Industry Challenges with Expert Guidance",
      description: [
        "The pharmaceutical, life sciences, and healthcare sectors are constantly evolving due to new discoveries, regulatory changes, and shifting market dynamics. Expert management consulting helps you adapt to these challenges with strategic clarity.",
        "Services such as competitive intelligence, strategic planning, and business development provide the insights and actionable strategies needed to optimize operations, stay ahead of competitors, and achieve sustainable success in a rapidly changing landscape.",
      ],
    },
    service_5: {
      title: "Market Research & Industry Trends",
      subtitle: "Unlock Key Insights to Drive Strategic Decisions",
      description: [
        "Staying ahead of market shifts is crucial for long-term success. Market research services provide a competitive edge by offering a deep understanding of industry trends, emerging technologies, and the competitive landscape.",
        "Whether it's R&D information, competitor analysis, or an overview of market dynamics, actionable insights are delivered to guide business strategies. with services such as market access research, pricing analysis, and social media audits, you gain the intelligence needed to make informed decisions and drive innovation.",
      ],
    },
    service_6: {
      title: "Scientific Writing & Editing",
      subtitle: "Communicate Your Innovations with Precision and Impact",
      description: [
        "Effective scientific communication is essential for sharing breakthroughs with the world. Expert scientific writing services help craft high-quality, professionally written documents for publications, proposals, and technical reports.",
        "By applying a deep understanding of scientific writing principles, content is crafted to be both precise and impactful. Whether it involves technical writing, literature reviews, or proposal drafting, these services ensure your research is communicated with clarity and authority, making a strong and lasting impression on your target audience.",
      ],
    },
    service_7: {
      title: "Non-Patent Searches & Analysis",
      subtitle: "Leverage In-Depth Literature Reviews to Inform Your Strategy",
      description: [
        "Before pursuing new projects or technologies, understanding existing knowledge is critical. Non-patent search and analysis services provide comprehensive reviews of publications including journal articles, book chapters, and research findings, offering valuable insights for your strategy.",
        "These in-depth reports help avoid duplication, identify market gaps, and refine your approach. Whether you're a patent attorney, researcher, or scientist, customized reports synthesize key information, equipping you with the knowledge needed to make informed, strategic decisions.",
      ],
    },

    subServices: {
      scientificSolutions: {
        title: "Scientific & Technology Solutions",
        description:
          "At Lifeintelect, we provide scientific, operational, and strategic solutions for various industry functions. Our team has extensive experience in both academia and industry, possessing both functional expertise and industry focus. with our in-depth knowledge, we assist our clients at every stage of the Idea to Innovation process.",
        processTitle:
          "We offer techno-legal consulting across a diverse range of disciplines, including:",
        process: [
          { title: "Life Sciences", description: "" },
          { title: "Healthcare", description: "" },
          { title: "Pharmaceuticals", description: "" },
          { title: "Medical Technology", description: "" },
          { title: "Agriculture", description: "" },
          { title: "Natural Medicine", description: "" },
          { title: "Fisheries", description: "" },
          { title: "Biofuels", tópicos: "" },
          { title: "Materials Processing", description: "" },
          { title: "Materials Synthesis", description: "" },
          {
            title: "Nanotechnology Research and Applications",
            description: "",
          },
          { title: "Clinical Research", description: "" },
          { title: "Chemistry", description: "" },
          { title: "Drug Discovery", description: "" },
          { title: "Environmental solutions", description: "" },
          { title: "Blockchain technology and AI", description: "" },
        ],
        image: scientificSolutions,
        closing:
          "We meticulously evaluate key aspects including R&D, technology, industry trends, market evolution, and growth opportunities. This thorough analysis helps us make critical decisions regarding company strategy, portfolio planning, commercial approaches, market access, and more.",
        closing1:
          "Our goal is to assist our clients in addressing their challenges and accelerating business transformation through innovation.",
        closing2:
          "Ready to transform your business with Lifeintelect's expertise? Let's get started!",
      },
      patentValuations: {
        title: "Patent Valuation Reports",
        subHeading: "Patent Valuation Reports",
        subTitle: "Quantify Potential. Justify Investment.",
        description:
          "A well-structured valuation report supports deal-making and technology transfers by delivering credible, defensible asset appraisals.",
        processTitle: "Valuation Components Include:",
        process: [
          {
            title: "Intrinsic Valuation Models:",
            description:
              "Deep analysis using cost, income, and market comparisons",
          },
          {
            title: "Monetization Pathways:",
            description:
              "Licensing potential, royalty forecasting, and acquisition interest",
          },
          {
            title: "Market Alignment: ",
            description:
              "Demand forecasting, trend analysis, and fit within competitive ecosystems",
          },
          {
            title: "Regulatory & IP Risk Review",
            description:
              "Assessment of enforceability, challenges, and compliance",
          },
        ],
        closing:
          "Stakeholders gain clear, actionable insight to support high-stakes IP decisions.",
      },
      drugDiscoveryDevelopment: {
        title: "Drug Discovery and Development",
        subHeading: "Drug Discovery and Development",
        subTitle: "Accelerate Your Drug Development Journey",
        description:
          "The life sciences and healthcare sectors are rapidly evolving, driven by new technologies and innovations. To stay ahead, making data-driven decisions early in the drug development process is crucial. Drug profiling is key to assessing a drug's efficacy, safety, and market potential, even before clinical trials begin.",
        description1:
          "with expertise in therapeutic clinical intelligence and competitive analysis, we provide in-depth insights into the competitive landscape, ongoing clinical trials, and emerging therapies, empowering you to make more informed, strategic decisions throughout the drug discovery process.",
        // process: [
        //   {
        //     title: "Drug Discovery & Development",
        //     description:
        //       "Drug profiling is performed to predict the efficacy, safety, and toxicity of drugs at the preclinical stage of drug development. It also explores targeted competitive products to enhance market prospects and estimate market penetration before launching a product or during the research phase. We offer customized drug profiling studies and analyses tailored to client requirements.",
        //     subPoints: [
        //       "Inventor/Maker of the Drug: Identifying the original creator or developer of the drug.",
        //       "Licensees: Listing the entities that have been granted licenses to manufacture or distribute the drug.",
        //       "Patent Expiration: Determining the expiration date of the drug's patent, which impacts market exclusivity.",
        //       "Chemical Information: Providing detailed chemical composition and structure of the drug.",
        //       "Target Receptor: Identifying the specific biological receptor that the drug targets.",
        //       "Mechanism of Action: Describing how the drug interacts with its target to produce its effects.",
        //       "Pharmacology Data: Including information on the drug's pharmacokinetics and pharmacodynamics.",
        //       "Usage: Outlining the recommended usage and dosage of the drug.",
        //       "Therapies and Indications: Specifying the medical conditions and indications the drug is intended to treat.",
        //       "Approvals (Country-Wise Information): Providing details on the regulatory approvals the drug has received in various countries.",
        //     ],
        //     closing:
        //       "with our comprehensive drug profiling services, you can ensure a thorough understanding of your drug's potential, making informed decisions to enhance its market prospects and successfully bring it to market.",
        //   },
        //   {
        //     title: "Therapeutic Clinical Intelligence",
        //     description:
        //       "The Therapeutic Clinical Intelligence Report provides clients with detailed information and analysis of competitive products in the development pipeline. It includes the competitive landscape of the drug and identifies potential collaborators. The report contains integrated information and analysis of clinical development activities for products and evaluations of completed and in-progress competitor studies. It summarizes important elements of the study protocol, offering comprehensive insights.",
        //     subPoints: [
        //       "The design of the clinical trial.",
        //       "The sponsor's name and country.",
        //       "The condition or indication being studied.",
        //       "The intervention drug, if any.",
        //       "The phase of the trial.",
        //       "The start and end dates.",
        //       "The study size and patient type.",
        //       "The number of participating sites.",
        //       "The dosing regimen.",
        //       "The endpoints.",
        //       "The safety and efficacy results.",
        //       "The supporting organization or institution.",
        //     ],
        //     closing:
        //       "with our comprehensive Therapeutic Clinical Intelligence services, you can gain valuable insights into the competitive landscape and make informed decisions about your clinical development strategy.",
        //   },
        //   {
        //     title: "Competitive Intelligence",
        //     description:
        //       "At Lifeintelect, we combine primary and secondary intelligence gathering of publicly available information with our analytical skills and domain expertise to provide in-depth, strategic, and broad-spectrum competitive intelligence reports. These reports come with recommendations and implications that add value to the drug discovery and development process and business strategies.",
        //     subPoints: [
        //       "Emerging profiles of competitors",
        //       "Company/product profiles",
        //       "Market landscape and trends analysis",
        //     ],
        //     closing:
        //       "with our comprehensive competitive intelligence services, you can stay ahead of the competition and make informed strategic decisions to enhance your business outcomes.",
        //   },
        //   {
        //     title: "R&D Information Solutions",
        //     description:
        //       "At Lifeintelect, our research and development information solutions primarily cater to the pharmaceuticals, life sciences, and healthcare ecosystems. We provide valuable insights and data to support innovation and strategic decision-making.",
        //     subPoints: [
        //       "Epidemiology & Disease Information",
        //       "Therapy Area Assessments",
        //       "In-Depth Analysis of Technology",
        //       "New Products in New Areas",
        //       "New Applications for Existing Products",
        //       "In-Vitro Diagnostics",
        //       "Life Science Research Tools",
        //     ],
        //   },
        // ],
        // closing:
        //   "with our research and development information solutions, you can stay ahead in the competitive landscape and make informed decisions to drive innovation and growth in your business. Ready to enhance your research and development strategy with Lifeintelect? Let's get started!",
        // subPoints: [
        //   "Analyzing the competitive landscape within a therapeutic area.",
        //   "Developing business decisions on clinical analogues.",
        //   "Benchmarking competitor clinical trial designs and results.",
        //   "Assessing key current and future competitors.",
        //   "Designing effective clinical trials for better market penetration.",
        // ],
        // closing1:
        //   "with Lifeintelect, you can be confident that your drug discovery and development processes are supported by thorough analysis, strategic insights, and cutting-edge solutions. Ready to enhance your innovation journey with Lifeintelect? Let's get started!",
      },
      patentDueDiligence: {
        title: "Patent Due Diligence & Variability Analysis",
        subHeading: "Patent Due Diligence & Variability Analysis",
        subTitle: "Validate Strength. Secure Position.",
        description:
          "Before entering deals or scaling innovation, understanding a patent's legal and commercial robustness is essential.",
        processTitle: "Due Diligence Coverage:",
        process: [
          {
            title: "Validity & Prior Art Checks: ",
            description:
              "Rigorous searches to confirm novelty, utility, and enforceability",
          },
          {
            title: "Legal Status & Ownership Clarity: ",
            description:
              "Verification of current ownership, oppositions, and encumbrances",
          },
          {
            title: "Claim Strength Analysis:",
            description:
              "Examination of scope, protection breadth, and freedom-to-operate",
          },
          {
            title: "Technology Adaptability: ",
            description:
              "Review of cross-domain application potential and integration feasibility",
          },
        ],
        closing:
          "Confidence in your IP starts with knowing it can stand up in court—and in the market.",
      },
      clinicalCommercialPotential: {
        title: "Assessment of Clinical & Commercial Potential",
        subHeading: "Assessment of Clinical & Commercial Potential",
        subTitle: "Position Your Innovations for Success",
        description:
          "Evaluating the clinical and commercial potential of patented technologies is essential to ensure they align with market needs and address key healthcare challenges. By analyzing clinical trials, FDA approvals, and emerging biotech trends, the real-world applicability of innovations is assessed.",
        description1:
          "Through market size estimation, projected growth, and return on investment (ROI) analysis, you can position your technology for success. Tailored patent licensing and commercialization strategies open the door to partnerships and opportunities, optimizing both the financial and strategic value of your innovations.",
        // title: "Assessment of Clinical & Commercial Potential",
        // description:
        //   "We provide detailed assessments to evaluate the clinical and commercial viability of patented technologies, ensuring alignment with market needs and strategic goals.",
        // process: [
        //   {
        //     title: "Application in Clinical & Biotech Markets",
        //     description:
        //       "We evaluate the real-world applicability of patented technologies in healthcare and biotechnology sectors by examining the scope of ongoing research, clinical trials, and FDA approvals. Our analysis forecasts the potential impact on addressing unmet medical needs and aligns with emerging biotech trends, enhancing the patent's strategic value. This comprehensive assessment ensures that the patented technology is positioned effectively within the evolving landscape of medical and biotechnological advancements.",
        //   },
        //   {
        //     title: "Market Size Estimation",
        //     description:
        //       "Our team conducts thorough evaluations of the market size, projected growth, and potential return on investment (ROI) for patented technologies. We provide insights into industry demand, competitive positioning, and financial viability, aiding in informed decision-making for commercialization strategies. By analyzing market dynamics and trends, we help clients understand the economic potential of their patented technologies and identify opportunities for growth and expansion.",
        //   },
        //   {
        //     title: "Patent Licensing & Commercialization Strategy",
        //     description:
        //       "We identify potential licensing partners, negotiate royalty structures, and explore acquisition opportunities to maximize the value of patented technologies. Our tailored strategies facilitate effective monetization pathways, ensuring optimal returns for patent holders and alignment with market needs. By leveraging our expertise in licensing and commercialization, we help clients navigate the complexities of bringing their innovations to market successfully.",
        //   },
        // ],
        //   closing:
        // 	"Lifeintelect’s assessments empower you to make informed decisions for successful commercialization and market growth. Ready to assess your technology’s potential with Lifeintelect? Let's get started!"
      },
      competitiveLandscape: {
        title: "Patent Landscaping Reports",
        subHeading: "Patent Landscaping Reports",
        subTitle: "Position Technologies. Navigate Markets.",
        description:
          "A comprehensive look at the IP landscape helps innovators and investors understand where technologies stand—and where they can lead.",
        processTitle: "Strategic Insights Include:",
        process: [
          {
            title: "Patent Mapping: ",
            description:
              "Identification of overlapping technologies, trends, and whitespace",
          },
          {
            title: "Competitive Analysis: ",
            description:
              "Profiles of key players, potential partners, and threats",
          },
          {
            title: "Novelty & Non-Obviousness Review: ",
            description:
              "Assessment of differentiation in current IP ecosystems",
          },
          {
            title: "Commercial Fit:  ",
            description:
              "Technology-to-market alignment and infringement risk detection",
          },
        ],
        closing:
          "Empower your technology with insights that clarify its path to market.",
      },
      managementConsulting: {
        // title: "Management Consulting",
        // description:
        //   "The Pharmaceuticals, Life Sciences, and Healthcare ecosystem is constantly evolving with changes in demographics, emerging technologies, new scientific discoveries, rising research and development costs, population demands, patent disputes, and transformed business models. At Lifeintelect, we provide thoughtful management consulting solutions to address these strategic and operational challenges. Regulatory reforms are fundamentally changing the relationships among major stakeholders across the industry. We leverage our core capabilities in research, analysis, and strategy development to offer tailored solutions.",
        // processTitle: "Our Management Consulting Services include:",
        // process: [
        //   {
        //     title: "Competitive Intelligence",
        //     description: "",
        //   },
        //   {
        //     title: "Strategic Planning",
        //     description: "",
        //   },
        //   {
        //     title: "Business Development",
        //     description: "",
        //   },
        //   {
        //     title: "Project Planning",
        //     description: "",
        //   },
        //   {
        //     title: "Business Research",
        //     description: "",
        //   },
        //   {
        //     title: "Branding",
        //     description: "",
        //   },
        // ],
        // closing:
        //   "with our expertise and comprehensive approach, we help you navigate the complexities of the industry and achieve your business objectives. Ready to transform your business with Lifeintelect's management consulting services? Let's get started!",
        // image: Pepole,
        // image: pen,
        title: "Management Consulting",
        subHeading: "Management Consulting",
        subTitle: "Navigate Industry Challenges with Expert Guidance",
        description:
          "The pharmaceutical, life sciences, and healthcare sectors are constantly evolving due to new discoveries, regulatory changes, and shifting market dynamics. Expert management consulting helps you adapt to these challenges with strategic clarity.",
        description1:
          "Services such as competitive intelligence, strategic planning, and business development provide the insights and actionable strategies needed to optimize operations, stay ahead of competitors, and achieve sustainable success in a rapidly changing landscape.",
      },
      marketResearch: {
        title: "Market Research & Industry Trends",
        subHeading: "Market Research & Industry Trends",
        subTitle: "Unlock Key Insights to Drive Strategic Decisions",
        description:
          "Staying ahead of market shifts is crucial for long-term success. Market research services provide a competitive edge by offering a deep understanding of industry trends, emerging technologies, and the competitive landscape.",
        description1:
          "Whether it's R&D information, competitor analysis, or an overview of market dynamics, actionable insights are delivered to guide business strategies. with services such as market access research, pricing analysis, and social media audits, you gain the intelligence needed to make informed decisions and drive innovation.",

        // title: "Market Research",
        // description:
        //   "We provide secondary market research and market landscape assessments for academics, businesses and individuals. Our research and analysis include a multi-stage approach which can be qualitative or quantitative or a combination of primary data research and exploration of secondary data sources.",
        // description1:
        //   "Our secondary research and analysis is effective for healthcare, medical and life sciences communities exploring new products or modifications in existing products including market insights, technology assessments, new drugs discovery & best-practice benchmarks, analyzes trends and intellectual property. We bring the right combination of expertise, insight and strategy, to assist our clients from technological innovations, competitive shifts, and evolving end-user requirements to regulatory changes.",
        // description2:
        //   "Our solutions can help clients in the following vital areas:",
        // processTitle: "Competitive intelligence solutions",
        // process: [
        //   {
        //     title: "Emerging profiles of competitors",
        //     description: "",
        //   },
        //   {
        //     title: "Compare/product profiles",
        //     description: "",
        //   },
        //   {
        //     title: "Market landscape and trends",
        //     description: "",
        //   },
        // ],
        // processTitle1: "R&D information solutions",
        // process1: [
        //   {
        //     title: "Epidemiology & disease information",
        //     description: "",
        //   },
        //   {
        //     title: "Therapy area assessments",
        //     description: "",
        //   },
        //   {
        //     title: "In-depth analysis of technology",
        //     description: "",
        //   },
        //   {
        //     title: "New products in new areas",
        //     description: "",
        //   },
        //   {
        //     title: "New applications for existing products",
        //     description: "",
        //   },
        //   {
        //     title: "In-vitro diagnostics",
        //     description: "",
        //   },
        //   {
        //     title: "Life science research tools",
        //     description: "",
        //   },
        // ],
        // processTitle2: "Market research solutions",
        // process2: [
        //   {
        //     title: "Market access and pricing research",
        //     description: "",
        //   },
        //   {
        //     title: "Media monitoring",
        //     description: "",
        //   },
        //   {
        //     title: "social media audits and analysis ",
        //     description: "",
        //   },
        // ],
        // closing:
        //   "with our comprehensive market research services, you can gain valuable insights and make informed decisions to drive innovation and growth in your business. Ready to enhance your market strategy with Lifeintelect? Let's get started!",
      },
      scientificWritingEditing: {
        // title: "Scientific Writing and Editing",
        // description:
        //   "Scientific writing is best done by scientists. At Lifeintelect, we are a team of scientists who have spent considerable time in academia and industry. We understand and appreciate our clients' needs, comprehend their goals, and use our expertise to design thoughtful and effective solutions. We create professionally written and articulate documents on a variety of scientific and technical subjects relevant to our clients’ businesses or needs.",
        // description1:
        //   "We help our clients maximize the accuracy and impact of their written documents to enhance their scientific publication and fundraising success. We offer professional, customized, and confidential scientific writing and editing services with rapid turnaround times. We conduct complex scientific and technical literature searches and analyses for patent and trademark attorneys, agents, scientists, and research managers.",
        // processTitle:
        //   "We offer a complete range of technical report writing services, including:",
        // process: [
        //   {
        //     title:
        //       "Extraction of valuable knowledge from resources such as articles, journals, patents, and online resources.",
        //     description: "",
        //   },
        //   {
        //     title: "Scientific editing and proofreading services.",
        //     description: "",
        //   },
        //   {
        //     title: "Technical writing services.",
        //     description: "",
        //   },
        //   {
        //     title: "Technical literature review.",
        //     description: "",
        //   },
        //   {
        //     title: "Proposal writing.",
        //     description: "",
        //   },
        // ],
        // closing:
        //   "with Lifeintelect’s scientific writing and editing services, you can be assured of high-quality, accurate, and impactful documents that meet your specific requirements. Ready to enhance your scientific writing with Lifeintelect? Let's get started!",
        // image: Geometry,
        // image: pen,
        title:"Scientific Writing & Editing",
        subHeading: "Scientific Writing & Editing",
        subTitle: "Communicate Your Innovations with Precision and Impact",
        description:
        "Effective scientific communication is essential for sharing breakthroughs with the world. Expert scientific writing services help craft high-quality, professionally written documents for publications, proposals, and technical reports.",
        description1:
        "By applying a deep understanding of scientific writing principles, content is crafted to be both precise and impactful. Whether it involves technical writing, literature reviews, or proposal drafting, these services ensure your research is communicated with clarity and authority, making a strong and lasting impression on your target audience.",
      
      },
      nonPatentSearches: {
        title:"Non-Patent Searches & Analysis",
        subHeading: "Non-Patent Searches & Analysis",
        subTitle: "Leverage In-Depth Literature Reviews to Inform Your Strategy",
        description:
        "Before pursuing new projects or technologies, understanding existing knowledge is critical. Non-patent search and analysis services provide comprehensive reviews of publications including journal articles, book chapters, and research findings, offering valuable insights for your strategy.",
        description1:
        "These in-depth reports help avoid duplication, identify market gaps, and refine your approach. Whether you're a patent attorney, researcher, or scientist, customized reports synthesize key information, equipping you with the knowledge needed to make informed, strategic decisions.",
      
        // title: "Non-Patent Searches and Analysis",
        // description:
        //   "Non patent search & analysis is referred as a critique of published work. The report contains a review and synthesis of the previously published literature on the topic important for the client. The reports are prepared based on reference prior work.",
        // description1:
        //   "We, at Lifeintelect have a strong technical team with in-depth domain expertise to assist our client in preparing technical literature review and project report that are professional, customized & confidential with rapid turnaround time. We conduct non-patent search & analysis for patent and trademark attorneys, agents, scientists and research managers.",
        // processTitle: "Non patent search and analysis",
        // process: [
        //   {
        //     title:
        //       "Detailed report that provides in-depth analysis of prior art.",
        //     description: "",
        //   },
        //   {
        //     title:
        //       "Extraction of valuable knowledge from resources such as articles, journals, patents, and online resources.",
        //     description: "",
        //   },
        //   {
        //     title: "Publications and report analysis",
        //     description: "",
        //   },
        // ],
        // //   closing:
        // // 	"With Lifeintelect’s scientific writing and editing services, you can be assured of high-quality, accurate, and impactful documents that meet your specific requirements. Ready to enhance your scientific writing with Lifeintelect? Let's get started!",
        // image: Pen_Hand,
        // closing:
          // "Lifeintelect’s non-patent search services deliver actionable insights for research and IP management. Ready to uncover critical insights with Lifeintelect? Let's get started!",
      },
    },
  },
};

export default subServiceContent;
